// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Urkv-","title":"Info_title__1AQLb","selects":"Info_selects__y8b6v","requiredAsterisk":"Info_requiredAsterisk__1qej4"};